import { en_US } from './en_US'

export enum Languages {
    en_US = 'en_US',
}

export const languages = {
    [Languages.en_US]: en_US
}
